module.exports = __webpack_public_path__ + "banquet/components/images/button_menu_close.f39facafd5fce2e3fdf82251f0ae1e3f.svg";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/button_menu_close.svg
// module id = 148
// module chunks = 0 1